import { z } from 'zod';

// Plant context schema
export const PlantContextSchema = z.object({
  scientificName: z.string().min(1, 'Scientific name is required'),
  commonName: z.string().min(1, 'Common name is required'),
  lastWatered: z.string().nullable(),
  location: z.string().nullable(),
});

// Diagnosis request schema
export const DiagnoseRequestSchema = z.object({
  plantId: z.string().min(1, 'Plant ID is required'),
  imageBase64: z.string().min(1, 'Image data is required'),
  plantContext: PlantContextSchema,
});

// Extend photo retention request schema
export const ExtendPhotoRetentionRequestSchema = z.object({
  plantId: z.string().min(1, 'Plant ID is required'),
  diagnosisId: z.string().min(1, 'Diagnosis ID is required'),
});

// Validation types
export type DiagnoseRequestInput = z.infer<typeof DiagnoseRequestSchema>;
export type ExtendPhotoRetentionInput = z.infer<typeof ExtendPhotoRetentionRequestSchema>;

// Plant form validation errors interface
export interface ValidationErrors {
  nickname?: string;
  location?: string;
  acquiredDate?: string;
}

// Validation error messages
export const ValidationErrorMessages = {
  NICKNAME_TOO_LONG: 'Nickname must be between 1 and 50 characters',
  LOCATION_TOO_LONG: 'Location must be between 1 and 100 characters',
  ACQUIRED_DATE_FUTURE: 'Acquired date cannot be in the future',
} as const;

/**
 * Validate a plant nickname (1-50 characters)
 */
export function isValidNickname(nickname: string): boolean {
  return nickname.length >= 1 && nickname.length <= 50;
}

/**
 * Validate a plant location (1-100 characters)
 */
export function isValidLocation(location: string): boolean {
  return location.length >= 1 && location.length <= 100;
}

/**
 * Validate that a date is not in the future
 */
export function isNotFutureDate(date: Date): boolean {
  return date <= new Date();
}
